export const sqlKeywords = [
  'SELECT',
  'INSERT',
  'UPDATE',
  'DELETE',
  'REPLACE',
  'FROM',
  'WHERE',
  'GROUP',
  'BY',
  'HAVING',
  'ORDER',
  'LIMIT',
  'OFFSET',
  'INTO',
  'VALUES',
  'SET',
  'DISTINCT',
  'AS',
  'INNER',
  'JOIN',
  'LEFT',
  'RIGHT',
  'FULL',
  'OUTER',
  'ON',
  'USING',
  'UNION',
  'UNION ALL',
  'INTERSECT',
  'EXCEPT',
  'CASE',
  'WHEN',
  'THEN',
  'ELSE',
  'END',
  'NULL',
  'NOT',
  'AND',
  'OR',
  'BETWEEN',
  'LIKE',
  'IN',
  'IS',
  'IS NOT',
  'EXISTS',
  'ANY',
  'ALL',
  'LIMIT',
  'OFFSET',
  'FETCH',
  'ROWNUM',
  'WITH',
  'CTE',
  'WINDOW',
  'OVER',
  'PARTITION BY',
  'CREATE',
  'ALTER',
  'DROP',
  'TRUNCATE',
  'RENAME',
  'TABLE',
  'VIEW',
  'INDEX',
  'PRIMARY',
  'FOREIGN',
  'CONSTRAINT',
  'KEY',
  'UNIQUE',
  'DEFAULT',
  'CHECK',
  'AUTO_INCREMENT',
  'SERIAL',
  'INT',
  'INTEGER',
  'BIGINT',
  'SMALLINT',
  'TINYINT',
  'DECIMAL',
  'NUMERIC',
  'FLOAT',
  'DOUBLE',
  'CHAR',
  'VARCHAR',
  'TEXT',
  'DATE',
  'TIME',
  'DATETIME',
  'TIMESTAMP',
  'BOOLEAN',
  'ENUM',
  'SET',
  'BINARY',
  'VARBINARY',
  'UUID',
  'JSON',
  'ARRAY',
  'DISTINCT',
  'SEQUENCE',
  'TRIGGER',
  'FUNCTION',
  'PROCEDURE',
  'EXPLAIN',
  'ANALYZE',
  'BEGIN',
  'COMMIT',
  'ROLLBACK',
  'SAVEPOINT',
  'RELEASE',
  'GRANT',
  'REVOKE',
  'DENY',
  'LOCK',
  'OPTIMIZE',
  'REPAIR',
  'FLUSH',
  'CACHE',
  'SHOW',
  'DESCRIBE',
  'USE',
  'DATABASE',
  'DATABASES',
  'TABLES',
  'USER',
  'PASSWORD',
  'CURRENT_USER',
  'SESSION_USER',
  'USER_DEFINED_FUNCTION',
  'CURRENT_TIMESTAMP',
  'CURRENT_DATE',
  'CURRENT_TIME',
  'CURRENT_TIMEZONE',
  'COALESCE',
  'NULLIF',
  'IFNULL',
  'ISNULL',
  'CONCAT',
  'CONVERT',
  'CAST',
  'GROUP_CONCAT',
  'REGEXP',
  'TRIM',
  'LENGTH',
  'SUBSTRING',
  'REPLACE',
  'POSITION',
  'LOCATE',
  'INSTR',
  'CHAR_LENGTH',
  'CHARACTER_LENGTH',
  'LEFT',
  'RIGHT',
  'UPPER',
  'LOWER',
  'ROUND',
  'CEIL',
  'FLOOR',
  'RAND',
  'ABS',
  'PI',
  'RADIANS',
  'DEGREES',
  'NOW',
  'SYSDATE',
  'DATE_FORMAT',
  'STR_TO_DATE',
  'DATE_ADD',
  'DATE_SUB',
  'TIMESTAMPDIFF',
  'TIMESTAMPADD',
  'ADDDATE',
  'SUBDATE',
  'DATE_TRUNC',
  'EXTRACT',
  'CAST',
  'CONVERT',
  'TRY_CAST',
  'TRY_CONVERT',
];

export const javascriptKeywords = [
  'abstract',
  'arguments',
  'await',
  'boolean',
  'break',
  'byte',
  'case',
  'catch',
  'char',
  'class',
  'const',
  'continue',
  'debugger',
  'default',
  'delete',
  'do',
  'double',
  'else',
  'enum',
  'eval',
  'export',
  'extends',
  'false',
  'final',
  'finally',
  'float',
  'for',
  'function',
  'goto',
  'if',
  'implements',
  'import',
  'in',
  'instanceof',
  'int',
  'interface',
  'let',
  'long',
  'native',
  'new',
  'null',
  'package',
  'private',
  'protected',
  'public',
  'return',
  'short',
  'static',
  'super',
  'switch',
  'synchronized',
  'this',
  'throw',
  'throws',
  'transient',
  'true',
  'try',
  'typeof',
  'var',
  'void',
  'volatile',
  'while',
  'with',
  'yield',
];

export const sqlKeywordsPink = [
  '@@error',
  'formatmessage',
  'newid',
  '@@identity',
  'getansinull',
  'permissions',
  '@@rowcount',
  'getdate',
  'session_user',
  '@@trancount',
  'host_id',
  'stats_date',
  'app_name',
  'host_name',
  'system_user',
  'current_timestamp',
  'ident_incr',
  'textptr',
  'current_user',
  'ident_seed',
  'textvalid',
  'datename',
  'user_name',
  'ascii',
  'soundex',
  'patindex',
  'space',
  'charindex',
  'replace',
  'str',
  'difference',
  'quotename',
  'stuff',
  'replicate',
  'substring',
  'len',
  'reverse',
  'unicode',
  'lower',
  'upper',
  'ltrim',
  'rtrim',
  'avg',
  'max',
  'binary_checksum',
  'min',
  'checksum',
  'sum',
  'checksum_agg',
  'stdev',
  'count',
  'stdevp',
  'count_big',
  'var',
  'grouping',
  'varp',
  '@@datefirst',
  '@@options',
  '@@dbts',
  '@@remserver',
  '@@langid',
  '@@servername',
  '@@language',
  '@@servicename',
  '@@lock_timeout',
  '@@spid',
  '@@max_connections',
  '@@textsize',
  '@@max_precision',
  '@@version',
  '@@nestlevel',
  '@@cursor_rows',
  'cursor_status',
  '@@fetch_status',
  'dateadd',
  'datediff',
  'datename',
  'datepart',
  'day',
  'getdate',
  'getutcdate',
  'month',
  'year',
  'abs',
  'degrees',
  'rand',
  'acos',
  'exp',
  'round',
  'asin',
  'floor',
  'sign',
  'atan',
  'log',
  'sin',
  'atn2',
  'log10',
  'square',
  'ceiling',
  'pi',
  'sqrt',
  'cos',
  'power',
  'tan',
  'cot',
  'radians',
  'col_length',
  'col_name',
  'fulltextcatalogproperty',
  'columnproperty',
  'fulltextserviceproperty',
  'databaseproperty',
  'index_col',
  'databasepropertyex',
  'indexkey_property',
  'db_id',
  'indexproperty',
  'db_name',
  'object_id',
  'file_id',
  'object_name',
  'file_name',
  'objectproperty',
  'filegroup_id',
  '@@procid',
  'filegroup_name',
  'sql_variant_property',
  'filegroupproperty',
  'typeproperty',
  'fileproperty',
  'is_srvrolemember suser_sid suser_sname user_id has_dbaccess',
  'user is_member',
  'app_name',
  'cast convert',
  'coalesce',
  'collationproperty',
  'current_timestamp',
  'current_user',
  'datalength',
  '@@error',
  'formatmessage',
  'getansinull',
  'host_id',
  'host_name',
  'ident_current',
  'ident_incr',
  'ident_seed',
  '@@identity',
  'isdate',
  'isnull',
  'isnumeric',
  'newid',
  'nullif',
  'parsename',
  'permissions',
  '@@rowcount',
  'scope_identity',
  'serverproperty',
  'sessionproperty',
  'session_user',
  'stats_date',
  'system_user',
  '@@trancount',
  'user_name',
  '@@connections',
  '@@pack_received',
  '@@cpu_busy',
  '@@pack_sent',
  '@@timeticks',
  '@@idle',
  '@@total_errors',
  '@@io_busy',
  '@@total_read',
  '@@packet_errors',
  '@@total_write',
  'patindex',
  'textptr',
  'textvalid',
];

export const csharpKeywords = [
  'abstract',
  'as',
  'base',
  'bool',
  'break',
  'byte',
  'case',
  'catch',
  'char',
  'checked',
  'class',
  'const',
  'continue',
  'decimal',
  'default',
  'delegate',
  'do',
  'double',
  'else',
  'enum',
  'event',
  'explicit',
  'extern',
  'false',
  'finally',
  'fixed',
  'float',
  'for',
  'foreach',
  'goto',
  'if',
  'implicit',
  'in',
  'int',
  'interface',
  'internal',
  'is',
  'lock',
  'long',
  'namespace',
  'new',
  'null',
  'object',
  'operator',
  'out',
  'override',
  'params',
  'private',
  'protected',
  'public',
  'readonly',
  'ref',
  'return',
  'sbyte',
  'sealed',
  'short',
  'sizeof',
  'stackalloc',
  'static',
  'string',
  'struct',
  'switch',
  'this',
  'throw',
  'true',
  'try',
  'typeof',
  'uint',
  'ulong',
  'unchecked',
  'unsafe',
  'ushort',
  'using',
  'virtual',
  'void',
  'volatile',
  'where',
  'while',
  'var',
];

export const vbKeywords = [
  'addhandler',
  'addressof',
  'alias',
  'and',
  'andalso',
  'as',
  'boolean',
  'byref',
  'byte',
  'byval',
  'call',
  'case',
  'catch',
  'cbool',
  'cbyte',
  'cchar',
  'cdate',
  'cdec',
  'cdbl',
  'char',
  'cint',
  'class',
  'clng',
  'cobj',
  'const',
  'continue',
  'csbyte',
  'cshort',
  'csng',
  'cstr',
  'ctype',
  'cuint',
  'culng',
  'cushort',
  'date',
  'decimal',
  'declare',
  'default',
  'delegate',
  'dim',
  'directcast',
  'do',
  'double',
  'each',
  'else',
  'end',
  'endif',
  'enum',
  'erase',
  'error',
  'event',
  'exit',
  'false',
  'finally',
  'for',
  'friend',
  'function',
  'get',
  'gettype',
  'getxmlnamespace',
  'global',
  'gosub',
  'goto',
  'handles',
  'if',
  'implements',
  'imports',
  'in',
  'inherits',
  'integer',
  'interface',
  'is',
  'isnot',
  'let',
  'lib',
  'like',
  'long',
  'loop',
  'me',
  'mod',
  'module',
  'mustinherit',
  'mustoverride',
  'mybase',
  'myclass',
  'namespace',
  'narrowing',
  'new',
  'next',
  'not',
  'nothing',
  'notinheritable',
  'notoverridable',
  'object',
  'of',
  'on',
  'operator',
  'option',
  'optional',
  'or',
  'orelse',
  'overloads',
  'overridable',
  'overrides',
  'paramarray',
  'partial',
  'private',
  'property',
  'protected',
  'public',
  'raiseevent',
  'readonly',
  'redim',
  'rem',
  'removehandler',
  'resume',
  'return',
  'sbyte',
  'select',
  'set',
  'shadows',
  'shared',
  'short',
  'single',
  'static',
  'step',
  'stop',
  'string',
  'structure',
  'sub',
  'synclock',
  'then',
  'throw',
  'to',
  'true',
  'try',
  'trycast',
  'typeof',
  'variant',
  'wend',
  'uinteger',
  'ulong',
  'ushort',
  'using',
  'when',
  'while',
  'widening',
  'with',
  'withevents',
  'writeonly',
  'xor',
  '#const',
  '#else',
  '#elseif',
  '#end',
  '#if',
];
